import React from "react";
import { SideBar } from "./sidebar";
import { getAllGroups } from "../../models/groups"; //getAllEndedGroups,
import DataTable from "react-data-table-component";
import i18n from "../../i18n";
//import swal from "sweetalert";
import { Modal, Spinner } from "react-bootstrap";
import { HomeBanner } from "../home/homeBanner";
import {
  getAllMeetings,
  getMeetingAttendees,
  statuses,
} from "../../models/meetings";
import { MzadLoader } from "../helpers/mzadLoader";
import { getLoggedUser } from "../../state/user";
import { getAllWinners, getMultipleWinners } from "../../models/auctions";
import { FinishMeeting } from "./meeting/finish_meeting";
import { WinnersMeeting } from "./meeting/winners_list";

const user = getLoggedUser();
let lang = localStorage.getItem("I18N_LANGUAGE");
const customStyles = {
  headCells: {
    style: {
      fontWeight: "bold",
      backgroundColor: "#dadada",
      color: "#000000",
    },
  },
};
const today = new Date().toISOString().split("T")[0];

export class TodaysMeetings extends React.Component {
  constructor() {
    super();
    this.state = {
      winners: [],
      meeting: {},
      groups: [],
      ended_groups: [],
      attendees: [],
      add: {},
      meetingID: null,
      signature: null,
      data: {},
      errors: {},
      is_loading: false,
      users: {},
      hideSidebar: false,
      totalRows: 0,
      currentPage: 1,
      input: {
        page: 1,
        limit: 15,
        date: today,
        status: "N",
      },
      screen_val: "1",
      edit_screen_val: "1",
      columns: [
        {
          name: "ID",
          sortable: true,
          wrap: true,
          width: "50px",
          cell: (row) => row.id,
        },
        {
          name: `${i18n.t("group")}`,
          cell: (row) => (row.group ? row?.group_info?.group_name : ""),
          sortable: true,
        },
        {
          name: i18n.t("title"),
          cell: (row) => {
            return `${row.title_ar} \r\n${row.title}`;
          },
          sortable: true,
          wrap: true,
        },
        {
          name: `${i18n.t("meeting")} ${i18n.t("number")}`,
          cell: (row) => {
            return `${row.number_ar} \r\n${row.number}`;
          },
        },
        {
          name: `${i18n.t("location")}`,
          cell: (row) => {
            return `${row.location_ar} \r\n${row.location}`;
          },
        },
        {
          name: `${i18n.t("final_approved_officer")}`,
          cell: (row) => {
            return row?.final_approved_officer
              ? `${row?.final_officer?.name_ar} \r\n${row?.final_officer?.name}`
              : "";
          },
        },
        {
          name: i18n.t("date"),
          width: "150px",
          cell: (row) => {
            return `${row.date}\r\n${i18n.t("start")}:${row.start_time
              }\r\n${i18n.t("end")}:${row.end_time}`;
          },
          sortable: true,
        },
        {
          name: i18n.t("status"),
          cell: (row) => statuses[row.status_label],
          sortable: true,
        },
        {
          name: i18n.t("attendees"),
          button: true,
          cell: (row) => (
            <button
              className="btn btn-primary rounded-0"
              onClick={(e) => {
                this.viewAttendees(row.id);
              }}
            >
              {i18n.t("attendees")}
            </button>
          ),
        },
        {
          name: i18n.t("action"),
          button: true,
          cell: (row) =>
            row.status !== "C" &&
            (user.role === "A" || user.role === "RS" || user.role === "O") && (
              <button
                className="btn btn-danger rounded-0"
                onClick={(e) => {
                  this.startMeeting(row);
                }}
              >
                {i18n.t("start")}
              </button>
            ),
        },
      ],
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.triggerReload = this.triggerReload.bind(this);
    this.loadAllGroups = this.loadAllGroups.bind(this);
    this.loadEndedGroups = this.loadEndedGroups.bind(this);
    this.loadWinners = this.loadWinners.bind(this);
  }

  componentDidMount() {
    this.loadEndedGroups();
    this.loadAllGroups();
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  async loadEndedGroups() {
    this.setState({ groups_loading: true });
    const response = await getAllGroups("");
    //const response = await getAllEndedGroups();
    if (response.success) {
      let ended_groups = response.data;
      this.setState({ ended_groups });
      this.setState({ groups_loading: false });
    }
  }

  async loadAllGroups() {
    this.setState({ groups_loading_2: true });
    const response = await getAllGroups();
    if (response.success) {
      let groups = response.data;
      this.setState({ groups });
      this.setState({ groups_loading_2: false });
    }
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  handleSearch(event) {
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  async loadAllMeetings(q) {
    this.setState({ is_loading: true });
    const response = await getAllMeetings(q);
    let users = response.data;
    let meta = response.meta;
    if (response.success) {
      this.setState({ is_loading: false });
      this.setState({ users: users });
      this.setState({ totalRows: meta.total });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async viewAttendees(id) {
    this.setState({ attendees_loading: true });
    const response = await getMeetingAttendees(id);
    if (response.success) {
      let data = response.data;
      this.setState({ attendees_popup: true, attendees: data });
      this.setState({ attendees_loading: false });
    }
  }

  // async startMeeting(row) {
  //   this.loadWinners(row.group);
  //   this.setState({ meeting_loading: true, meeting: row });
  //   const response = await getMeetingAttendees(row?.id);
  //   if (response.success) {
  //     let data = response.data;
  //     this.setState({ meeting_popup: true, attendees: data });
  //     this.setState({ meeting_loading: false });
  //   }
  // }

  async startMeeting(row) {
    console.log("startMeeting row:", row);

    // collect groups (meeting may have multiple groups)
    const groups = row.groups && row.groups.length > 0
      ? row.groups.map(g => g.id || g.group)
      : row.group
        ? [row.group]
        : [];

    console.log("Resolved groups:", groups);

    this.setState({ meeting_loading: true, meeting: row });

    const response = await getMeetingAttendees(row?.id);
    if (response.success) {
      let data = response.data;

      if (groups.length > 1) {
        await this.loadMultipleWinners(groups); // 🔹 multiple groups
      } else if (groups.length === 1) {
        await this.loadWinners(groups[0]);      // 🔹 single group
      }

      this.setState({
        meeting_popup: true,
        attendees: data,
        meeting_loading: false,
      });
    } else {
      this.setState({ meeting_loading: false });
    }
  }


  async loadMultipleWinners(groups = [], auctions = []) {
  console.log("loadMultipleWinners called with:", groups, auctions);

  if ((!groups || groups.length === 0) && (!auctions || auctions.length === 0)) {
    console.warn("No groups or auctions provided → skipping API call");
    return;
  }

  this.setState({ winners: [], winners_loading: true });

  const response = await getMultipleWinners({ groups, auctions });

  console.log("getMultipleWinners response:", response);

  if (response.success && response.data) {
    this.setState({ winners: response.data, winners_loading: false });
  } else {
    this.setState({ winners_loading: false });
  }
}





  handlePageChange = (page) => {
    let input = this.state.input;
    let currentPage = page;
    input["page"] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ input: input });
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllMeetings(qstring);
  };

  triggerReload() {
    let { input } = this.state;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  // async loadWinners(group) {
  //   if (group) {
  //     this.setState({ winners_loading: true });
  //     const response = await getAllWinners({ group: group });
  //     if (response.data) {
  //       this.setState({ winners: response.data });
  //       this.setState({ winners_loading: false });
  //     } else {
  //       this.setState({ winners_loading: false });
  //     }
  //   }
  // }

  async loadWinners(group) {
    console.log("loadWinners called with group:", group);

    if (!group) {
      console.warn("No valid group id provided → skipping API call");
      return;
    }

    this.setState({ winners: [], winners_loading: true });
    const response = await getAllWinners({ group });
    console.log("getAllWinners response:", response);

    if (response.success && response.data) {
      this.setState({ winners: response.data, winners_loading: false });
    } else {
      this.setState({ winners_loading: false });
    }
  }




  render() {
    let {
      users,
      groups,
      attendees,
      attendees_loading,
      meeting_popup,
      meeting_loading,
      meeting,
      winners,
    } = this.state;
    return (
      <React.Fragment>
        <HomeBanner />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card mb-0">
                  <div className="card-header d-flex justify-content-between">
                    <div className=" d-flex">
                      <span
                        style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && (
                          <i className="icon-size-actual"></i>
                        )}
                        {!this.state.hideSidebar && (
                          <i className="icon-size-fullscreen"></i>
                        )}
                      </span>
                      <h3 className="card-title">
                        {i18n.t("todays")}&nbsp;{i18n.t("meetings")}
                      </h3>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive ">
                      {this.state.is_loading && (
                        <div className="text-center">
                          <Spinner animation="border" size="lg" />
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <input
                              type="date"
                              name="date"
                              value={this.state.input.date}
                              onChange={this.handleChange}
                              className="form-control custom-input "
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <input
                              type="text"
                              name="number"
                              value={this.state.input.number}
                              onChange={this.handleChange}
                              className="form-control custom-input "
                              placeholder={i18n.t("number")}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="group"
                              value={this.state.input.group}
                              onChange={this.handleChange}
                            >
                              <option value="">-- {i18n.t("group")} --</option>
                              {groups.length > 0 &&
                                groups.map((item) => {
                                  return (
                                    <option value={item.id} key={item.id}>
                                      {lang === "ar"
                                        ? item.group_name_ar
                                        : item.group_name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="meeting_status"
                              value={this.state.input.meeting_status}
                              onChange={this.handleChange}
                            >
                              <option value="">-- {i18n.t("status")} --</option>
                              {Object.keys(statuses).length > 0 &&
                                Object.entries(statuses).map(([key, value]) => (
                                  <option value={key} key={key}>
                                    {value}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <button
                              className="btn btn-primary"
                              onClick={this.handleSearch}
                            >
                              <i className="fa fa-search" />
                            </button>
                          </div>
                        </div>
                        {(this.state.input.qtext || this.state.input.rank) && (
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                className="btn btn-outline-danger btn-block"
                                onClick={(e) => {
                                  let { input } = this.state;
                                  input.qtext = "";
                                  input.rank = "";
                                  this.setState({ input });
                                  this.handleSearch(e);
                                }}
                              >
                                <i className="fa fa-times" />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {!this.state.is_loading && users.length > 0 && (
                        <div className="table-wrapper">
                          <DataTable
                            title=""
                            fixedHeader
                            columns={this.state.columns}
                            data={users}
                            customStyles={customStyles}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={this.state.totalRows}
                            paginationPerPage={15}
                            paginationDefaultPage={this.state.currentPage}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: i18n.t("meetings"),
                              rangeSeparatorText: i18n.t("out"),
                            }}
                            onChangePage={this.handlePageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal
          size="lg"
          show={this.state.attendees_popup}
          onHide={() => this.setState({ attendees_popup: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t("attendees")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader
              animation="grow"
              size="md"
              loading={attendees_loading}
              style={{ position: "relative" }}
            />
            {!attendees_loading && attendees.length === 0 && (
              <div className="alert alert-danger">
                {i18n.t("no_data_found")}
              </div>
            )}
            {!attendees_loading && attendees.length > 0 && (
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>{i18n.t("id")}</th>
                    <th>{i18n.t("name")}</th>
                    <th>{i18n.t("approved")}</th>
                    <th>{i18n.t("notes")}</th>
                  </tr>
                </thead>
                <tbody>
                  {attendees.map((item) => {
                    return (
                      <tr>
                        <td>{item.id}</td>
                        <td>
                          <div>
                            {lang === "ar"
                              ? item?.officer_info?.name_ar
                              : item?.officer_info?.name}
                          </div>
                          <div>
                            <small className="text-muted">
                              {item.officer && item.officer_rank
                                ? lang === "ar"
                                  ? item?.officer_rank?.rank_ar
                                  : item?.officer_rank?.rank_en
                                : ""}
                            </small>
                          </div>
                        </td>
                        <td>
                          <span
                            className={`badge bg-${item.approved ? "success" : "danger"
                              }`}
                          >
                            {item.approved ? i18n.t("yes") : i18n.t("no")}
                          </span>
                        </td>
                        <td>{item?.notes}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>

        {/* <Modal
          size="lg"
          show={meeting_popup}
          onHide={() => this.setState({ meeting_popup: false })}
          fullscreen
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
               {i18n.t("meeting")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader
              animation="grow"
              size="md"
              loading={meeting_loading}
              style={{ position: "relative" }}
            />
            <div className="row">
              <div className="col-4">
                <div className="card m-0 border border-1 p-2 bg-light">
                  <h4>
                    {i18n.t("auction_winners")}(
                    {lang === "ar"
                      ? meeting?.group_info?.group_name_ar
                      : meeting?.group_info?.group_name}
                    )
                  </h4>
                  <WinnersMeeting winners={winners} lang={lang} />
                </div>
              </div>

              <FinishMeeting
                attendees={attendees}
                meetingId={meeting.id} 
                onFinished={(isFinished) => {
                  if (isFinished) {
                    this.setState({ meeting_popup: false });
                  }
                }}
              />
            </div>
          </Modal.Body>
        </Modal> */}

        <Modal
          size="xl"
          show={meeting_popup}
          onShow={() => this.loadWinners(this.state.meeting?.group)} // 🔹 ensures reload
          onHide={() => this.setState({ meeting_popup: false })}
          fullscreen
          centered
        >

          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <i className="bi bi-people-fill me-2"></i>
              {i18n.t("meeting")}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <MzadLoader
              animation="grow"
              size="md"
              loading={meeting_loading}
              style={{ position: "relative" }}
            />

            <div className="row g-3">
              {/* Winners Section */}
              <div className="col-lg-4">
                <div className="card h-100">
                  <div className="card-header bg-light fw-bold">
                    {i18n.t("auction_winners")} (
                    {lang === "ar"
                      ? meeting?.group_info?.group_name_ar
                      : meeting?.group_info?.group_name}
                    )
                  </div>
                  <div className="card-body p-3">
                    <div className="table-responsive" style={{ maxHeight: "350px" }}>
                      <WinnersMeeting winners={winners} lang={lang} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Attendees Section */}
              <div className="col-lg-8">
                <div className="card  h-100">
                  <div className="card-header bg-light fw-bold d-flex align-items-center">
                    <i className="bi bi-person-check-fill me-2 text-success"></i>
                    {i18n.t("attendees")}
                  </div>
                  <div className="card-body p-3">
                    <div className="table-responsive" style={{ maxHeight: "550px" }}>
                      <FinishMeeting
                        attendees={attendees}
                        meetingId={meeting.id}
                        onFinished={(isFinished) => {
                          if (isFinished) this.setState({ meeting_popup: false });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-end">
            <button
              className="btn btn-secondary"
              onClick={() => this.setState({ meeting_popup: false })}
            >
              {i18n.t("close")}
            </button>
          </Modal.Footer>
        </Modal>


      </React.Fragment>
    );
  }
}
